import { sortBy } from "lodash";

const completedFirst = (obj) => !obj.complete;
const alphabetical = (obj) => obj.name;

const adSort = (ads) => sortBy(ads, [completedFirst, alphabetical]);

export default adSort;
